export const VersionIxeEnum = Object.freeze({
  R3: 'R3',
  R7: 'R7'
});